export class EnumHelper {
  static keys<T extends Record<string, string | number>>(enumObj: T): Array<Extract<keyof T, string>> {
    return Object.keys(enumObj).filter((k) => isNaN(Number(k))) as Array<Extract<keyof T, string>>;
  }

  static values<T extends Record<string, string | number>>(enumObj: T): Array<T[keyof T]> {
    return this.keys(enumObj).map((k) => enumObj[k]);
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  static valueByKey<T extends Record<string, string | number>, K extends keyof T>(enumEl: T, key: K): T[K] {
    return enumEl[key];
  }
}
